// extracted by mini-css-extract-plugin
module.exports = {"about":"contact-module--about--zPM1T","contact":"contact-module--contact--1exrD","copyright":"contact-module--copyright--2toL5"};